module.exports = __webpack_public_path__ + "static/img/dllogo1.166e2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/dllogo1.jpg
// module id = kXIT
// module chunks = 2